export default "__VITE_ASSET__ChDVMLuw__"